import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Sidebar = () => {
  const [tasksOpen, setTasksOpen] = useState(true);
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  return (
    <ul className="nav sidebar-menu flex-column">
      {/* Dashboard */}
      <li className={`nav-item ${isActive("/assistant-manager/dashboard") ? "active" : ""}`}>
        <Link to="/assistant-manager/dashboard" className="nav-link">
          <i className="nav-icon bi bi-speedometer"></i>
          <p>Dashboard</p>
        </Link>
      </li>

      {/* Live Chat */}
      <li className={`nav-item ${isActive("/assistant-manager/live-chat") ? "active" : ""}`}>
        <Link to="/assistant-manager/live-chat" className="nav-link">
          <i className="nav-icon bi bi-chat-dots"></i>
          <p>Live Chat</p>
        </Link>
      </li>

      {/* Meetings */}
      <li className={`nav-item ${isActive("/assistant-manager/meetings/list") ? "active" : ""}`}>
        <Link to="/assistant-manager/meetings/list" className="nav-link">
          <i className="nav-icon bi bi-calendar-event"></i>
          <p>Meeting Management</p>
        </Link>
      </li>

      {/* Tasks */}
      <li className={`nav-item ${tasksOpen ? "menu-open" : ""}`}>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            setTasksOpen(!tasksOpen);
          }}
          className="nav-link"
        >
          <i className="nav-icon bi bi-list-task"></i>
          <p>
            Tasks
            <i
              className={`right bi ${
                tasksOpen ? "bi-chevron-up" : "bi-chevron-down"
              } ms-2`}
            ></i>
          </p>
        </a>

        {tasksOpen && (
          <ul className="nav nav-treeview ps-3">
            <li
              className={`nav-item ${
                isActive("/assistant-manager/tasks/create") ? "active" : ""
              }`}
            >
              <Link to="/assistant-manager/tasks/create" className="nav-link">
                <i className="bi bi-plus-circle nav-icon"></i>
                <p>Create Task</p>
              </Link>
            </li>
            <li
              className={`nav-item ${
                isActive("/assistant-manager/tasks/list") ? "active" : ""
              }`}
            >
              <Link to="/assistant-manager/tasks/list" className="nav-link">
                <i className="bi bi-list-ul nav-icon"></i>
                <p>Manage Task</p>
              </Link>
            </li>
          </ul>
        )}
      </li>

      {/* E-sign Consent Form */}
      <li className={`nav-item ${isActive("/assistant-manager/sign-consent/view") ? "active" : ""}`}>
        <Link to="/assistant-manager/sign-consent/view" className="nav-link">
          <i className="nav-icon bi bi-pencil-square"></i>
          <p>E-sign Consent Form</p>
        </Link>
      </li>
    </ul>
  );
};

export default Sidebar;
